export const QUERY = {
  q: 'q',
  keywords: 'keywords',
  bookmarksIds: 'bIds',
  hasLangChanged: 'hasLangChanged',
  complain: 'complain',
  paidServices: 'paid_services',
  button: 'button',
  mobileSite: 'mobile_site',
  price: 'price',
  regionId: 'region_id',
  categoryId: 'categoryId',
  awaitingPayment: 'awaiting_payment',
  userId: 'user_id',
  keywordsSource: 'keywords_source',
  slug: 'slug',
  accessToken: 'access_token',
  transitionSourceBlock: 'transition_source_block',
  isShop: 'is_shop',
};

export enum Languages {
  Ru = 'ru',
  Az = 'az',
}

export const USER_NAME_MAX_LENGTH = 30;

export const BOOKMARKS_CHUNK_SIZE = 24;
export const COLLECTIONS_CHUNK_SIZE = 24;

export enum DateTimeFormat {
  fullTime = 'dd.MM.yyyy, HH:mm',
  fullTimeHyphenated = 'dd-MMM-yy, HH:mm',
  date = 'dd.MM.yyyy',
  timeFirstDate = 'HH:mm, dd.MM.yyyy',
  timeDate = 'HH:mm dd.MM.yyyy',
  time = 'HH:mm',
  longMonthWithYear = 'dd MMMM yyyy',
}

export const OPERATOR_CODE_LENGTH = 3;

export const OPERATOR_CODES = [
  '010',
  '050',
  '051',
  '055',
  '099',
  '070',
  '077',
  '060',
  '044',
  '012',
  '018',
  '020',
  '021',
  '022',
  '023',
  '024',
  '025',
  '026',
  '036',
];

export const ROOT_CATEGORY_SLUG = 'elanlar';

export const CATEGORIES_SLUGS_COUNT = 3;

export const SINGLE_AD_PAGE_SLUGS_COUNT = 4;

export enum PAGE_WITH_ADS {
  HOME = 'home',
  SEARCH_RESULTS = 'search_results',
  USER_ADS = 'user_ads',
}

export const AZERICARD_DELAY_TIME_MS = 5000;
